import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeStep: 0,
  drawerOpen: false,
  projectInputStep: 0
}

const mainTool = createSlice({
  name: 'mainTool',
  initialState,
  reducers: {
    setActiveStep(state, action) {
      state.activeStep = action.payload
    },
    setDrawerOpen(state, action) {
      state.drawerOpen = action.payload
    },
    setProjectInputStep(state, action) {
      state.projectInputStep = action.payload
    }
  }
})

export const { setActiveStep, setDrawerOpen, setProjectInputStep } =
  mainTool.actions
export default mainTool.reducer
